module.exports = __webpack_public_path__ + "static/media/refillz.2064e777.jpg";